export default function ButtonIcon({ icon: Icon, children, size = 18 }) {
  if (!Icon) return children;
  return (
    <>
      <Icon size={size} />
      {children != null && children !== '' && <span>{children}</span>}
    </>
  );
}
